import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import api from './modules/api'
import auth from './modules/auth'
import analytics from './modules/analytics'
import statistics from './modules/statistics'
import maps from './modules/maps'

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    api,
    auth,
    analytics,
    statistics,
    maps,
  }
})
